import VendeurAcheteurCommonTypes from "@/modules/vendeurAcheteurCommonTypes";

const VendeurTypes: {[key: string]: {key: string; label: string; background?: string; color?: string}} = {
    ...VendeurAcheteurCommonTypes,
};

export default VendeurTypes;
